export class Modulo10Validator {

    private static readonly TEN = 10;
    private static readonly EVEN_CROSS_SUM_MULTIPLIER = 2;

    /**
     * Prüfziffernberechnung TR-ID, SR-ID, SG-ID, Malo-ID
     *
     * Die Prüfziffernberechnung erfolgt nach folgendem Schema:
     *  1. Quersumme aller Zahlen in ungerader Position
     *  2. Quersumme aller Zahlen auf gerader Position multipliziert mit 2
     *  3. Summe von 2) und 3)
     *  4. Differenz von 4) zum nächsthöheren Vielfachen von 10 (ergibt sich hier 10, wird die Prüfziffer 0 genommen)
     *
     *
     *  Beispiel 1: Code: 65(A) 1 1 3 7 3 5 5 9 2 PZ
     *  1. 65 + 1 + 7 + 5 + 9 = 87
     *  2. (1 + 3 + 3 + 5 + 2) * 2 = 28
     *  3. 87 + 28 = 115
     *  4. 120 - 115 = 5 => Prüfziffer 5
     *
     *      Code: A 1 1 3 7 3 5 5 9 2 5
     *
     *
     *  Beispiel 2: Code: 68(D) 0 8 1 5 65(A) 2 3 6 7 PZ
     *  1. 68 + 8 + 5 + 2 + 6 = 89
     *  2. (0 + 1 +65 + 3 + 7) * 2 = 152
     *  3. 89 + 152 = 241
     *  4. 250 – 241 => Prüfziffer 9
     *
     *      Code: D 0 8 1 5 A 2 3 6 7 9
     */
    static isValid(resourceIds: number[]): boolean {
        if (resourceIds.length === 0) {
            throw new Error('InvalidArgumentExcpetion - resourceIds needs to have at least one element');
        }
        const checkDigit = resourceIds.pop();
        // Hint: Index starts at 0 and natural counting starts at 1, so dont mind this even, odd naming scheme
        const oddValues = resourceIds.filter((_value, index, _array) => index % 2 == 0);
        const evenValues = resourceIds.filter((_value, index, _array) => index % 2 == 1);

        const oddCrossSum = oddValues.reduce((acc, curr) => acc + curr, 0);
        const evenCrossSum = (evenValues.reduce((acc, curr) => acc + curr, 0)) * this.EVEN_CROSS_SUM_MULTIPLIER;

        const totalSum = oddCrossSum + evenCrossSum;
        const diffBetweenNextMultipleOfTen = (this.TEN - (totalSum % this.TEN)) % this.TEN;

        return checkDigit == diffBetweenNextMultipleOfTen;
    }
}


